import React from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import {URLS} from "@/lib/urls";
import {Button} from 'antd';
import toFaNumber from "@/lib/utils/number";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchStudentScores} from "@/api/score";
import RenderIf from "@/components/render-if";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";

function StudentScoresPage(props) {
    const columns = [
        {
            title: 'شناسه درس',
            dataIndex: 'id',
            key: 'id',
            responsive: ['sm'],
            render: (text) => toFaNumber(text)
        },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => {
                return record?.lesson?.topic?.title
            }
        },
        {
            title: 'مربی',
            dataIndex: 'teacher',
            key: 'teacher',
            render: function (text, record) {
                return record?.lesson?.teacher_detail?.firstname + ' ' +
                    record?.lesson?.teacher_detail?.lastname;
            }
        },
        {
            title: 'نمره',
            dataIndex: 'scores',
            key: 'scores',
            render: (text, record) => {
                return (
                    <div className="flex flex-wrap gap-2">
                        <RenderIf condition={!!record?.score}
                                  falsyElement={
                                      <span className="text-slate-400 text-sm">-</span>
                                  }>
                            <span className="text-sm">{record?.score}</span>
                        </RenderIf>
                    </div>

                )
            }
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            render: function (text, record) {
                return (<div className={'flex justify-end'}>

                    <Link to={sprintf(URLS.student.lessons.myLesson.detail, {id: text})}>
                        <Button size={'small'} color={'default'} variant={'filled'}>جزئیات</Button>
                    </Link>
                </div>)
            }
        },

    ];

    return (
        <StudentLayout pageTitle={'نمرات'} backTo={URLS.student.dashboard}>
            <TableSearch
                searchInput={false}
                apiFn={useApiSearchStudentScores}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />
        </StudentLayout>
    );
}

export default StudentScoresPage;


